<template>
  <div class="drivers-heatmap driver-demographic-wrap">
    <div class="subdriver-analysis-wrap">
      <nav class="top-nav">
        <ul>
          <li
            v-for="(s,index) in sortByData"
            :key="index"
            :id="index"
          >
            <div class="top-menu"
              :id="s"
              @click="onClickSortBy(index)"
              :class="activeSort === index ? 'top-menu--active' : ''"
            >
              <div class="top-menu__title"> {{s}} </div>
            </div>
          </li>
        </ul>
      </nav>
      <div class="nav-body">
        <driver-bar
          ref="driverBar"
          :chartData="chartData"
        ></driver-bar>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import DriverBar from './driver-bar';

import DriversMixin from '../drivers-mixins';

export default {
  name: 'DriverDemographic',

  mixins: [DriversMixin],

  components: {
    DriverBar
  },

  props: {
    activeDriver: {
      required: true,
      type: String
    },
    activeSubdriver: {
      required: true,
      type: String
    },
    activeQuestion: {
      required: false,
      type: String
    },
    sortByData: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      activeSort: '',
      chartData: []
    };
  },

  watch: {
    sortByData: {
      deep: true,
      immediate: true,
      handler () {
        if (this.sortByData) {
          const opt = Object.entries(this.sortByData)[0];
          if (opt) {
            if (opt[0] !== 'location') {
              this.onClickSortBy(opt[0]);
            }
            this.resetHeatmap(opt[0]);
          }
        }
      }
    },
    driversDemographic: {
      deep: true,
      immediate: true,
      handler () {
        this.chartData = this.driversDemographic;
        setTimeout(() => {
          this.createChart();
        }, 100);
      }
    }
  },

  methods: {
    createChart () {
      if (this.$refs && this.$refs.driverBar) {
        this.$refs.driverBar.isLoading = true;
        this.$refs.driverBar.createChart(this.chartData);
      }
    },
    resetHeatmap (sortBy) {
      // console.log('onClickSortBy -> idx', idx);
      this.activeSort = sortBy;
      if (this.$refs.heatmap) {
        this.$refs.heatmap.page = 0;
      }
      if (this.$refs && this.$refs.driverBar) {
        this.$refs.driverBar.isLoading = true;
      }
    },
    onClickSortBy (sortBy) {
      this.activeSort = sortBy;
      this.resetHeatmap(sortBy);
      this.getDemographic();
    },
    fixedEncodeURIComponent (str) {
      return encodeURIComponent(str).replace(/[!'()*]/g, (c) => {
        return '%' + c.charCodeAt(0).toString(16);
      });
    },
    getDemographic () {
      this.isViewLoading = true;
      const filters = Object.assign({}, this.updateDriversFilters);
      if (filters && filters.filters) {
      // filters.filters have the dynamic filters value
        delete filters.filters;
      }
      const queryParams = {
        sub_driver: this.activeSubdriver || undefined,
        // question: this.activeQuestion || undefined,
        sort_key: `session__user__user_profile__${this.activeSort}`,
        driver: this.activeDriver || undefined,
        fields: 'demographic_wise_score',
        ...filters
      };
      if (this.activeQuestion) {
        // queryParams.question = this.activeQuestion.replace(') ', ')').replace(' (', '(');
        queryParams.question = this.fixedEncodeURIComponent(this.activeQuestion);
      }
      if (this.updateDriversFilters && this.updateDriversFilters.filters) {
        this.$lodash.each(this.updateDriversFilters.filters, (v, k) => {
          if (v.length > 0) {
            queryParams[`user__profile__${k}__in`] = v.join();
          }
        });
      }
      axios.get(`${process.env.VUE_APP_API_URL}driver/${this.activeDriver}/details`, {
        params: queryParams
      }).then((response) => {
        // console.log('response', response);
        this.$store.dispatch('driversDemographic', []);
        if (response && response.status === 200 && response.data && response.data.demographic_wise_score && response.data.demographic_wise_score.value) {
          this.chartData = [];
          this.$lodash.each(response.data.demographic_wise_score.value, (val, key) => {
            const t = {};
            t.key = key;
            t.value = val;
            this.chartData.push(t);
          });
          this.$store.dispatch('driversDemographic', this.chartData);
          // this.$store.dispatch('driverData', response.data);
          // if (response.data && response.data.interaction_responses) {
          // this.$store.dispatch('driversResponses', response.data.interaction_responses);
          // }
          // this.$nextTick(() => {
          //   this.isViewLoading = false;
          // });
        } else {
          this.chartData = [];
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch details, Please try again later!'
          });
          throw new Error(response);
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch details, Please try again later!'
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.driver-demographic-wrap {
  .subdriver-analysis-wrap {
    // padding: 16px;
    .analysis-heading {
      font-size: 16px;
      font-weight: var(--heading-weight);
      color: var(--color-content);
      padding-bottom: 16px;
      text-align: center;
    }
    .top-nav {
      z-index: 0;
      position: relative;
      ul {
        display: flex;
        list-style: none;
        margin: 0;
        padding: 0;
        padding: 0 25px;
        li {
          position: relative;
          .top-menu {
            height: 48px;
            border-top-left-radius: 0.5rem;
            border-top-right-radius: 0.5rem;
            display: flex;
            align-items: center;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            // color: var(--bg);
            font-size: var(--content-size);
            position: relative;
            .top-menu__title {
              display: flex;
              align-items: center;
              white-space: nowrap;
              cursor: pointer;
            }
            &.top-menu--active {
              background-color: var(--bg-panel);
              :before {
                content: "";
                width: 20px;
                height: 20px;
                margin-left: -20px;
                transform: rotate(90deg) scale(1.04);
                background-size: 100%;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23faf8fb'/%3E%3C/svg%3E%0A");
                position: absolute;
                bottom: 0;
                left: 0;
              }
              :after {
                content: "";
                width: 20px;
                height: 20px;
                margin-right: -20px;
                transform: rotate(180deg) scale(1.04);
                background-size: 100%;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23faf8fb'/%3E%3C/svg%3E%0A");
                position: absolute;
                bottom: 0;
                right: 0;
              }
              .top-menu__title {
                color: var(--color-headings);
                font-weight: var(--heading-weight);
              }
            }
            &:hover {
              background-color: var(--bg-panel);
            }
          }
        }
      }
    }
    .nav-body {
      background-color: var(--bg-panel);
      // padding: 16px;
    }
  }
}
</style>

<style scoped>
.driver-demographic-wrap[min-width~="768"] .top-menu {
  font-size: 14px !important;
}
.driver-demographic-wrap[min-width~="800"] .top-menu {
  font-size: 16px !important;
}
</style>
